export default "__VITE_ASSET__31944290__"